var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-editor-wrap"},[_c('codemirror',{ref:"cm",attrs:{"value":_vm.value,"options":_vm.options},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }